export const musicList = [
	{
		id: 1,
		title: "3 Old Viennese Dances Liebesleid",
		source: "assets/audios/liebesleid.mp3",
		cover: "assets/cover/liebesleid.jpg",
		artist: "Fritz Kreisler(arr. Sergei Rachmaninoff) ",
		performer: "Charles Rosen",
	},
	{
		id: 2,
		title: "海の見える街  〜魔女の宅急便",
		source: "assets/audios/jazz.mp3",
		cover: "assets/cover/jazz.jpg",
		artist: "Joe Hisaishi",
		performer: "Cafe Music BGM channel",
	},
	{
		id: 3,
		title: "Kass' Theme",
		source: "assets/audios/Kass.mp3",
		cover: "assets/cover/zelda.jpg",
		artist: "The Legend of Zelda: Breath of the Wild OST",
		performer: "LEGEND OF ZELDA",
	},
	// {
	//     id: "4",
	// 	title: "",
	// 	source: "",
	// 	cover: "",
	// 	artist: "",
	//     performer: '',
	// },
	// {
	//     id: "5",
	// 	title: "",
	// 	source: "",
	// 	cover: "",
	// 	artist: "",
	//     performer: '',
	// },
];
